import { HttpContextToken } from '@angular/common/http';

/**
 * Etichetta type-safe attaccata alla singola richiesta HTTP.
 * Quando vale `true`, il loadingInterceptor NON mostra il loader globale.
 * Sostituisce il vecchio hack del prefisso '@' nella stringa della route.
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);
